import { useCallback, useState } from "react";
import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppLabel } from "../../../../shared/components/AppLabel";
import { AppInput } from "../../../../shared/components/AppInput";
import { getBots, isTokenExist } from "../../helpers";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import {
  changeBotApiAction,
  createChatbotObjectAction,
} from "../../redux/actions";
import { TAddBotModal } from "../../types/types";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds, subtype: string) => void;
  addBotModalType: TAddBotModal;
}

export const AddNewBotModal: React.FC<Props> = ({
  closeModal,
  addBotModalType,
  className,
}) => {
  const dispatch = useAppDispatch();
  const addBotModal = useModalSelectors("add_new_bot_modal");
  const { objects } = useStorageSelectors("ai_agents_telegram_bots");
  const [token, setToken] = useState<string>("");
  const { t } = useTranslation();

  const isExistToken = isTokenExist(token, getBots(objects));

  const handleAddBot = useCallback(
    (modalType: TAddBotModal) => {
      if (modalType === "add_from_sidebar" || modalType === "add_from_folder") {
        dispatch(createChatbotObjectAction(token));
        closeModal("add_new_bot_modal", modalType);
      } else {
        dispatch(changeBotApiAction(token));
        return;
      }
    },
    [token, addBotModalType],
  );

  return (
    <ModalBasic
      open={addBotModal.isOpen && addBotModal.subtype === addBotModalType}
      title={
        addBotModalType === "add_from_sidebar" ||
        addBotModalType === "add_from_folder"
          ? t("chatbot_dialogs.new_bot")
          : t("chatbot_dialogs.change_api")
      }
      buttonOkText={
        addBotModalType === "add_from_sidebar" ||
        addBotModalType === "add_from_folder"
          ? t("chatbot_dialogs.add_button")
          : t("chatbot_dialogs.change_button")
      }
      onOk={() => handleAddBot(addBotModalType)}
      closeModal={() => closeModal("add_new_bot_modal", addBotModalType)}
      onClose={() => closeModal("add_new_bot_modal", addBotModalType)}
      hasFooter
      hasHeader
    >
      <div className={styles["input-container"]}>
        <div className={styles["label-container"]}>
          <AppLabel className={styles.label}>
            {t("chatbot_dialogs.bot_token")}
          </AppLabel>
          {isExistToken && (
            <AppLabel className={styles["error-label"]}>
              {t("chatbot_dialogs.error_token_exist")}
            </AppLabel>
          )}
        </div>
        <AppInput
          value={token}
          onChange={(e) => setToken(e.target.value)}
          className={styles.input}
        />
      </div>
    </ModalBasic>
  );
};
